<div class="form-group">
    <label *ngIf="title">{{title}} {{controlArray | controlRequiredText}}
    </label>

    <div class="dropdown dropdown-filter dropdown-input-filter dropdown-filter-categories dropdown-one-line-txt-btn"
        [id]="id + '-dp'">
        <button class="btn dropdown-toggle dropdown-toggle-no-arrow" type="button" [id]="id" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            {{placeholder}}
        </button>
        <div class="dropdown-menu dropdown-menu-filter">
            <div class="mgn-bottom-10">
                <label [for]="id + '-search'" class="accesibleHidden">{{placeholderSearch}}</label>
                <input type="text" class="form-control filter-input" [id]="id + '-search'"
                    [placeholder]="placeholderSearch" />
            </div>

            <div class="no-result-ctn d-none ">
                No se encontraron resultados
            </div>
            <div class="wrap-checkbox-group">

                <div class="checkbox-group" *ngFor="let e of dataSelectGroup">

                    <span class="group-heading text-capitalize">{{e.parent}}</span>
                    <div *ngFor="let s of e.items" class="wrap-checkbox">
                        <label class="checkbox-label" [for]="id + s.id">
                            <input type="checkbox" [id]="id + s.id"
                                [formControl]="controlArray.at(s.id | dynamicPipe: pipeIndex : [])">
                            <span class="checkmark"></span>
                            {{s.id | dynamicPipe: pipeName: [] }}
                        </label>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
